module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-GB_1.429d820e.jpg";